import "./submitButton.scss";
import Loading from "../../assets/images/loading.svg";

export default function SubmitButton({ text, loading, onClick }) {
  return (
    <button className="submitButton" onClick={onClick}>
      {loading ? <img src={Loading} alt="loading" width={20} /> : text}
    </button>
  );
}
